import request from "@/utils/request";

/**
 * 用户登录(个人、企业)
 * @param {String} account - 用户名
 * @param {String} password - 密码
 * @param {String} code - 短信验证码
 * @returns Promise
 */
export const userAccountLogin = ({ account, password, code }) => {
  return request("/auth/login", "post", { account, password, code });
};

/**
 * 获取短信登录验证码
 * @param {String} mobile - 手机号
 * @returns Promise
 */
export const userMobileLoginMsg = (mobile) => {
  return request("/login/code", "get", { mobile });
};
/**
 * 短信登录
 * @param {String} mobile - 手机号
 * @param {String} code - 验证码
 * @returns Promise
 */
export const userMobileLogin = ({ mobile, code }) => {
  return request("/login/code", "post", { mobile, code });
};
/**
 *  qq 第三方登录
 * @param {String} unionId - 第三方登录唯一标识
 * @param {Integer} source - 来源 1为pc，2为webapp，3为微信小程序，4为Android，5为ios,6为qq,7为微信
 * @returns Promise
 */
export const userQQLogin = (unionId, source = 1) => {
  return request("/login/social", "post", { unionId, source });
};
/**
 * qq 第三方登录-获取短信登录验证码
 * @param {String} mobile - 手机号
 * @returns Promise
 */
export const userQQBindCode = (mobile) => {
  return request("/login/social/code", "get", { mobile });
};
/**
 * qq 第三方登录-通过短信绑定进行登录
 * @param {String} mobile - 手机号
 * @param {String} unionId - 第三方登录唯一标识
 * @param {String} code - 验证码
 * @returns Promise
 */
export const userQQBindLogin = ({ unionId, mobile, code }) => {
  return request("/login/social/bind", "post", { unionId, mobile, code });
};
/**
 * 校验帐号（用户名）是否存在
 * @param {String} account - 帐号
 * @returns Promise
 */
export const userCheckAccount = (account) => {
  return request("/register/check", "get", { account });
};
/**
 * 获取短信验证码-注册-PC （完善信息callback-patch）
 * @param {String} account - 帐号
 * @returns Promise
 */
export const userQQPitchCode = (mobile) => {
  return request("/register/code", "get", { mobile });
};
/**
 *  (完善信息)通过短信绑定进行登录 三方登录-完善信息
 * @param {String} mobile - 手机号
 *  @param {String} unionId - 第三方登录唯一标识openId
 * @param {String} code - 验证码
 * @param {String} account - 帐号
 * @param {String} password - 密码
 * @returns Promise
 */
export const userQQPatchLogin = ({
  unionId,
  mobile,
  code,
  account,
  password,
}) => {
  return request(`/login/social/${unionId}/complement`, "post", {
    unionId,
    mobile,
    code,
    account,
    password,
  });
};
// 解绑电话号
export const unBindMobile = (mobile) => {
  return request("/login/social/unbind", "get", { mobile });
};

/**
 *  注册（个人）
 * @param {String} account - 帐号
 * @param {String} mobile - 手机号
 * @param {String} cert_type - 身份证件类型
 * @param {String} password - 密码
 * @param {String} realname - 姓名
 * @param {String} cert_no - 证件号码
 * @returns Promise
 */
export const register = ({
  account,
  password,
  realname,
  cert_type,
  cert_no,
  mobile,
}) => {
  return request("/register/person", "post", {
    account,
    password,
    realname,
    cert_type,
    cert_no,
    mobile,
  });
};

/**
 *  注册（企业）
 * @param {String} account - 帐号
 * @param {String} mobile - 手机号
 * @param {String} cert_type - 身份证件类型
 * @param {String} password - 密码
 * @param {String} realname - 姓名
 * @param {String} cert_no - 证件号码
 * @param {String} company_name - 企业名称
 * @param {String} company_type - 企业类型
 * @param {String} company_code - 企业组织机构代码
 * @returns Promise
 */
export const registerCompany = ({
  account,
  password,
  realname,
  cert_type,
  cert_no,
  mobile,
  company_name,
  company_type,
  company_code,
}) => {
  return request("/register/company", "post", {
    account,
    password,
    realname,
    cert_type,
    cert_no,
    mobile,
    company_name,
    company_type,
    company_code,
  });
};

/**
 *  个人用户找回密码
 * @param {String} mobile - 手机号
 * @param {String} cert_type - 身份证件类型
 * @param {String} password - 密码
 * @param {String} cert_no - 证件号码
 * @returns Promise
 */
export const findPerson = ({ password, cert_type, cert_no, mobile }) => {
  return request("/find/person", "post", {
    password,
    cert_type,
    cert_no,
    mobile,
  });
};

/**
 *  企业用户找回密码
 * @param {String} mobile - 手机号
 * @param {String} cert_type - 身份证件类型
 * @param {String} password - 密码
 * @param {String} cert_no - 证件号码
 * @param {String} company_code - 企业组织机构代码
 * @returns Promise
 */
export const findCompany = ({
  password,
  cert_type,
  cert_no,
  mobile,
  company_code,
}) => {
  return request("/find/company", "post", {
    password,
    cert_type,
    cert_no,
    mobile,
    company_code,
  });
};

/**
 *  获取用户资料信息
 * @returns Promise
 */
export const userProfile = () => {
  return request("/user/profile", "post");
};

/**
 *  用户绑定手机号
 * @param {String} mobile - 手机号
 * @returns Promise
 */
export const userUpdateMobile = ({ mobile }) => {
  return request("/user/updateMobile", "post", { mobile });
};

/**
 *  用户绑定联系地址
 * @param {String} address - 用户联系地址
 * @returns Promise
 */
export const userUpdateAddress = ({ address }) => {
  return request("/user/updateAddress", "post", { address });
};
/**
 *  用户修改密码(登录状态)
 * @param {String} mobile - 手机号
 * @param {String} newpass - 新密码
 * @returns Promise
 */
export const userSetPassword = ({ mobile ,newpass}) => {
  return request("/user/setPassword", "post", { mobile ,newpass});
};
/**
 * 获取短信验证码-注册-PC
 * @param {String} mobile - 手机号
 * @returns Promise
 */
export const getRegisterCodePc = (mobile) => {
  return request("/register/code", "get", { mobile });
};
